<p style="display: none">Client version: {{ clientVersion }}</p>
<app-toast />

<ngx-spinner size="medium" name="globalLoader">
  <p class="text-lg font-semibold text-white" i18n>Loading...</p>
</ngx-spinner>

@if (!isLoading()) {
  <router-outlet />
} @else {
  <app-background-image [showBody]="false">
    <ng-container transparent>
      <span class="loading loading-dots loading-lg"></span>
    </ng-container>
  </app-background-image>
}

<dialog #disconnectedDialog class="modal">
  <form method="dialog" class="modal-box text-start">
    <div class="modal-header flex flex-row items-center justify-center">
      <i class="fa-regular fa-wifi-exclamation w-auto px-2 text-lg" aria-hidden="true"></i>
      <h2 class="text-center font-bold" i18n>You are offline!</h2>
    </div>
    <div class="modal-body">
      <p i18n>
        Your browser seems to be having issues reaching our servers. You can try reloading the page.
      </p>
      <p i18n>Double check your internet connection, or switch to a different network.</p>
    </div>
    <div class="modal-action">
      <button class="btn btn-primary w-full" i18n (click)="reloadPage()">Reload</button>
    </div>
  </form>
</dialog>

<dialog #activeCompanyDialog class="modal">
  <form method="dialog" class="modal-box text-start">
    <div class="modal-header flex flex-row items-center justify-center">
      <h2 class="text-center font-bold" i18n>No Active Companies</h2>
    </div>
    <div class="modal-body space-y-5">
      <p i18n class="mx-auto max-w-prose text-center">
        You can't log in because you don't have any active company.
      </p>
      <p class="mx-auto max-w-prose text-center" i18n>
        Contact your company admin if you think something is wrong.
      </p>
    </div>
    <div class="modal-action">
      <button
        id="closeModalButton"
        class="btn btn-primary mx-auto"
        i18n
        (click)="activeCompanyDialog.close()">
        Close
      </button>
    </div>
  </form>
</dialog>
